import { useState, useContext } from 'react';
import {
  Container,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  Alert,
} from '@mui/material';
import AuthContext from '../AuthContext';
import { apiFetch } from '../api';

export default function BulkUploadPage() {
  const [files, setFiles] = useState([]);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const { token } = useContext(AuthContext);

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const handleUpload = async () => {
    if (files.length === 0) return;
    setMessage(null);
    setError(null);
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    try {
      const response = await apiFetch('/api/logs/', {
        method: 'POST',
        headers: token ? { Authorization: `Token ${token}` } : {},
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Upload failed');
      }
      setMessage('Upload successful');
      setFiles([]);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Bulk Upload
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      <Button variant="contained" component="label">
        Select Files
        <input hidden multiple type="file" onChange={handleFileChange} />
      </Button>
      {files.length > 0 && (
        <List sx={{ mt: 2 }}>
          {files.map((file, idx) => (
            <ListItem key={idx}>
              <ListItemText primary={file.name} />
            </ListItem>
          ))}
        </List>
      )}
      <Button
        variant="contained"
        sx={{ mt: 2 }}
        onClick={handleUpload}
        disabled={files.length === 0}
      >
        Upload
      </Button>
    </Container>
  );
}
